import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, {  useEffect, useState } from "react";
import Swal from "sweetalert2";
import formatDate from "../helpers/date.helper";
import formatMoney from "../helpers/money.helper";
import { getuser } from "../helpers/user.helper";
import { getBillsByCustomer } from "../services/bills.service";
import { getPayments, deleteItem } from "../services/payments";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import Footer from "../components/Footer";
import LoaderStatus from "../components/common/LoaderComponent";

export default function PagamentosList() {
  const [customerId, setcustomerId] = useState(undefined);
  const [paymentsResponse, setpaymentsResponse] = useState();
  const [showNewPayment, setshowNewPayment] = useState(false);

  useEffect(() => {
    let user = getuser();
    //Redireciona caso não esteja logado
    if (!user) {
      //navigate("/login");
    }

    async function fetchData() {
      await requestPayments();
    }

    fetchData();
  }, []);

  // const onLoadCustomer = async () => {
  //   let result = await GetCustomer(customerId);
  //   if (result?.data && result?.data.length > 0)
  //     setcustomerName(result?.data[0].nome);
  // };

  const requestPayments = async () => {
    let result = await getPayments(customerId);
    if (result) setpaymentsResponse(result.data);
  };

  const onHandleClickShowPayment = () => {
    setshowNewPayment(true);
  };

  const onLoadPaymentsCustomer = async () => {
    let response = await getBillsByCustomer(customerId);
    setpaymentsResponse(response?.data);
  };

  const onHandleChangeCustomerId = async (customerId) => {
    setcustomerId(customerId);

    // if (customerId.length === 7) {
    //   await onLoadCustomer();
    // }
  };

  const formatPaymentsType = (payment) => {
    if (payment === "P") {
      return "PARCIAL";
    } else if (payment === "T") {
      return "TOTAL";
    } else {
      return payment;
    }
  };

  const getCodVendedor = (cod) => {
    if (cod) return cod.padStart(6, "0");
  };

  const handleDeleteItem = async (item) => {
    Swal.fire({
      title: "<strong>Apagar pagamento</strong>",
      icon: "question",
      html: "Deseja remover pagamento? ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        await deleteItem(item.id);
      }
    });
  };

  const optionButtons = (rowData, column) => {
    return (
      <div>
        {getuser().type === "A" && (
          <button
            onClick={() => handleDeleteItem(rowData)}
            title="Apagar item"
            type="button"
            className="btn btn-icon btn-danger btn-sm"
          >
            <i className="fa fa-trash"></i>
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="pagamentos" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">Pagamentos</h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <section className="col-lg-12 connectedSortable">
                  <div className="card">
                    <div className="card-header" style={{ cursor: "pointer" }}>
                      <div className="card-tools">
                        <ul className="nav nav-pills ml-auto"></ul>
                      </div>
                      <div className="card-body">
                      {!paymentsResponse ? (
                        <LoaderStatus />
                      ) : (
                        <DataTable
                          value={paymentsResponse}
                          style={{ marginBottom: 50 }}
                          paginator
                          rows={100}
                          className="p-datatable-customers"
                          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                          currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                          emptyMessage="Nenhum pagamento a listar."
                        >
                          <Column field="id" header="Código" />
                          <Column
                            field={(row) => formatDate(row.data_pagamento)}
                            header="Data"
                            filter={true}
                          />
                          <Column field="nome_cliente" header="Cliente" />
                          <Column
                            field="cod_cliente"
                            header="Cod. Cliente"
                            filter={true}
                          />
                          <Column
                            field={(row) => formatMoney(row.valor_recebido)}
                            header="Valor Recebido"
                          />
                          <Column
                            field="numero_pedido"
                            header="Pedido"
                            filter={true}
                          />
                          <Column
                            field={(row) =>
                              formatPaymentsType(row.tipo_pagamento)
                            }
                            header="Tipo Pagamento"
                            filter={true}
                          />
                          <Column
                            field="forma_pagamento"
                            header="Forma Pagamento"
                            filter={true}
                          />

                          <Column
                            field={(row) => getCodVendedor(row.cod_supervisor)}
                            header="Vendedor"
                            filter={true}
                          />
                          <Column
                            field="supervisor"
                            header="Supervisor"
                            filter={true}
                          />

                          <Column
                            key="123"
                            body={optionButtons}
                            bodyStyle={{
                              textAlign: "center",
                              overflow: "hidden",
                            }}
                          />
                        </DataTable>
                      )}                        
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="row"></div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}
